function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const Image = _ref => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    style: {
      width: size,
      height: size
    },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation'
  }), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M20 4.75L19.25 4v16l.75-.75H4l.75.75V4L4 4.75h16zM3.25 4v16c0 .414.336.75.75.75h16a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75H4a.75.75 0 0 0-.75.75zm11.07 8.888c.23-.357.606-.353.828-.008l2.887 4.482c.227.352.06.638-.357.638H6.326c-.421 0-.581-.3-.37-.648l4.006-6.622c.217-.358.567-.359.793.014l2.396 3.96 1.17-1.816zm1.59-2.735c1.14 0 2.066-.907 2.066-2.026 0-1.12-.926-2.027-2.067-2.027s-2.066.907-2.066 2.027c0 1.119.925 2.026 2.066 2.026z"
  }, " "));
};

Image.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Image;